import React, { useEffect, useState } from "react";
import { Container, Table, Input, InputGroup } from "rsuite";
import { Col, Row } from "react-bootstrap";
import { getTripsTemplates } from "../../../../api/modules";
import { errorToast } from "../../../../services/toastService";
import LogButton from "../../../../components/atoms/LogButton";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import CloseIcon from "@rsuite/icons/Close";
import { Search } from "@rsuite/icons";

const { Column, HeaderCell, Cell } = Table;

function FilterHeaderCell({ title, value, onChange, onClear }) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: 60,
        position: "absolute",
        right: 2,
        left: 2,
      }}
    >
      {title && (
        <span
          style={{ fontWeight: "bold", fontSize: "14px", marginBottom: "4px" }}
        >
          {title}
        </span>
      )}
      <InputGroup
        inside
        size="xs"
        style={{
          maxWidth: 200,
          alignSelf: "center",
          height: "24px",
          fontSize: "12px",
        }}
      >
        <Input placeholder="Filtrar..." value={value} onChange={onChange} />
        {value ? (
          <InputGroup.Button onClick={onClear}>
            <CloseIcon />
          </InputGroup.Button>
        ) : (
          <InputGroup.Button style={{ cursor: "unset" }}>
            <Search />
          </InputGroup.Button>
        )}
      </InputGroup>
    </div>
  );
}

function TemplateTrip() {
  const [template, setTemplate] = useState([]);
  const [data, setData] = useState([]);
  const [filters, setFilters] = useState({
    origin_site: "",
    origin: "",
    destiny_site: "",
    destiny: "",
    product: "",
  });

  const history = useHistory();

  const fetchTemplate = async () => {
    const response = await getTripsTemplates();
    const { trips, msg } = response;
    if (msg) {
      errorToast(msg);
      setData([]);
    } else {
      setData(
        trips.map((item) => ({
          ...item,
          product: item.product?.product_type_name,
          origin_site: item.origin_site?.site_name,
          destiny_site: item.destiny_site?.site_name,
          additional_origin_indications:
            item.origin_site.additional_indications,
          additionl_destiny_indications:
            item.destiny_site.additional_indications,
          destiny: item.destiny?.toLowerCase(),
          origin: item.origin?.toLowerCase(),
        }))
      );
    }
  };

  useEffect(() => {
    fetchTemplate();
  }, []);

  useEffect(() => {
    let filteredData = [...data];

    Object.entries(filters).forEach(([key, value]) => {
      if (value) {
        filteredData = filteredData.filter((item) =>
          (item[key] || "").toLowerCase().includes(value.toLowerCase())
        );
      }
    });

    setTemplate(filteredData);
  }, [filters, data]);

  const handleFilterChange = (dataKey, value) => {
    setFilters((prev) => ({ ...prev, [dataKey]: value }));
  };

  return (
    <Container fluid>
      <Row>
        <Col>
          <h1 className="text-primary h3 font-weight-bold">
            Seleccionar viaje
          </h1>
        </Col>
      </Row>
      <Row className="mt-4">
        <Col md="12">
          <Table
            height={550}
            bordered
            cellBordered
            wordWrap={true}
            data={template}
            headerHeight={70}
          >
            <Column align="center" width={60}>
              <HeaderCell>Cant</HeaderCell>
              <Cell dataKey="repetitions" />
            </Column>

            <Column flexGrow={1} minWidth={160} align="center">
              <HeaderCell>
                <FilterHeaderCell
                  title="Origen"
                  value={filters.origin_site}
                  onChange={(value) => handleFilterChange("origin_site", value)}
                  onClear={() => handleFilterChange("origin_site", "")}
                />
              </HeaderCell>
              <Cell dataKey="origin_site" className="text-capitalize" />
            </Column>

            <Column flexGrow={1} minWidth={100} align="center">
              <HeaderCell>
                <FilterHeaderCell
                  title="Tipo origen"
                  value={filters.origin}
                  onChange={(value) => handleFilterChange("origin", value)}
                  onClear={() => handleFilterChange("origin", "")}
                />
              </HeaderCell>
              <Cell dataKey="origin" className="text-capitalize" />
            </Column>

            <Column flexGrow={1} minWidth={160} align="center">
              <HeaderCell>
                <FilterHeaderCell
                  title="Destino"
                  value={filters.destiny_site}
                  onChange={(value) =>
                    handleFilterChange("destiny_site", value)
                  }
                  onClear={() => handleFilterChange("destiny_site", "")}
                />
              </HeaderCell>
              <Cell dataKey="destiny_site" className="text-capitalize" />
            </Column>

            <Column flexGrow={1} minWidth={110} align="center">
              <HeaderCell>
                <FilterHeaderCell
                  title="Tipo destino"
                  value={filters.destiny}
                  onChange={(value) => handleFilterChange("destiny", value)}
                  onClear={() => handleFilterChange("destiny", "")}
                />
              </HeaderCell>
              <Cell dataKey="destiny" className="text-capitalize" />
            </Column>

            <Column flexGrow={1} minWidth={110} align="center">
              <HeaderCell>
                <FilterHeaderCell
                  title="Producto"
                  value={filters.product}
                  onChange={(value) => handleFilterChange("product", value)}
                  onClear={() => handleFilterChange("product", "")}
                />
              </HeaderCell>
              <Cell dataKey="product" className="text-capitalize" />
            </Column>

            <Column width={120} align="center">
              <HeaderCell></HeaderCell>
              <Cell>
                {(rowData) => (
                  <LogButton
                    title={"Repetir"}
                    size="sm"
                    border="curve"
                    onClick={() => {
                      history.push("/app/travels?preview=true", {
                        previewEntity: {
                          destiny_site: rowData._id.destiny_site,
                          origin_site: rowData._id.origin_site,
                          additional_origin_indications:
                            rowData.additional_origin_indications,
                          additionl_destiny_indications:
                            rowData.additionl_destiny_indications,
                          origin: rowData._id.origin,
                          destiny: rowData._id.destiny,
                          product: rowData._id.product,
                        },
                        previewLabels: {
                          charger_type: "",
                          truck_features: [],
                          truck_type: [],
                          truck_accessories: [],
                          payment_type: "",
                          destiny_site: rowData.destiny_site,
                          origin_site: rowData.origin_site,
                          product: rowData.product,
                        },
                      });
                    }}
                  />
                )}
              </Cell>
            </Column>
          </Table>
        </Col>
      </Row>
    </Container>
  );
}

export default TemplateTrip;
